
const NotificationCard = () => {
     return (
     <div id='main-notification-card' className='main-notification-card'></div>
     )
}

export default NotificationCard